import React from 'react';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusValue, currency } from '../data/copy';
export function BonusesSection() {
  return <section id="bonos" className="defer-paint w-full scroll-mt-6 bg-mist py-12 sm:py-14" aria-labelledby="bonuses-heading" data-id="element-14" data-mp="vsmhs9wuu65s">
      <div className="mx-auto max-w-5xl px-6" data-id="element-15" data-mp="qsrsubwn3qnd">
        <SectionHeading eyebrow="Incluido 100% gratis" eyebrowTone="gold" title={<span id="bonuses-heading" data-id="element-17" data-mp="14rzwpi3qzmxw">5 bonos explosivos</span>} lead={`Valor total: ${bonusValue} ${currency}. Hoy van incluidos sin cargo extra.`} data-id="element-16" data-mp="qw5vzmd4o3vv" />

        {/* Tarjeta vertical: portada arriba, etiqueta del bono, título y una
            sola línea de beneficio. Dos por renglón. */}
        <ul className="mt-9 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-3" data-id="element-18" data-mp="19llzmik40cgi">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col rounded-2xl border border-line bg-shell p-4 sm:p-5" data-id="element-19" data-mp="1nkvgzlk1xcm2">
              <div className="flex items-center justify-between gap-2" data-id="element-20" data-mp="1jkbiadjty0xt">
                <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.2em] text-muted" data-id="element-21" data-mp="3prn5w0zy1f4d">
                  Bono {bonus.number}
                </p>
                <span className="shrink-0 rounded-full bg-gold px-2 py-0.5 font-sans text-[9px] font-bold uppercase tracking-[0.14em] text-ink" data-id="element-22" data-mp="2lvtek1fy9nk">
                  Gratis
                </span>
              </div>

              <img src={bonus.image} alt={bonus.alt} className="mt-3 w-28 rounded-lg object-cover shadow-soft sm:w-36 sm:rounded-xl" width={1024} height={1024} sizes="144px" loading="lazy" decoding="async" {...{
            fetchpriority: 'low'
          }} data-id="element-23" data-mp="ckbkwo4drkxl" />

              <h3 className="mt-4 font-display text-lg font-bold leading-snug text-ink sm:text-xl" data-id="element-24" data-mp="leg8myo7wg8w">
                {bonus.title}
              </h3>

              <p className="mt-2 font-sans text-[0.82rem] leading-relaxed text-muted" data-id="element-25" data-mp="vbcl1fh8lmiq">
                {bonus.tagline}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}